import script from "./CSG.vue?vue&type=script&setup=true&lang=js"
export * from "./CSG.vue?vue&type=script&setup=true&lang=js"

import "./CSG.vue?vue&type=style&index=0&id=c79f7ee2&lang=css"

const __exports__ = script;

export default __exports__